import cookieManager from '../../../../utils/cookieManager';
import axios from '@/enhancers/axios';
import RouteActions from '../../../../reducers/modules/user/route/actions';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import { Navigate } from 'react-router-dom';

const MySwal = withReactContent(Swal)
const url=process.env.REST_URL +'user-access/routes'

export default class RouteMiddleware {

  static beforeAssign(data){
    return (dispatch) => {
      dispatch(RouteActions.beforeAssign());
      RouteMiddleware.assign(dispatch, data);
    };
  }

  static assign(dispatch,data){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${RouteMiddleware.getToken()}`
        },
        url:url,
        responseType: 'json',
        data:data
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(RouteActions.afterAssign(response.data.result));
          RouteMiddleware.alertHendler(dispatch, response, true, 'Save Data Successfully', 'success')
        }
      })
      .catch((error) => {
        RouteMiddleware.alertHendler(dispatch,error)
      });
  }


  static beforeRevoke(data){
    return (dispatch) => {
      dispatch(RouteActions.beforeRevoke());
      RouteMiddleware.revoke(dispatch, data);
    };
  }

  static revoke(dispatch,data){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${RouteMiddleware.getToken()}`
        },
        url:url+'/revoke',
        responseType: 'json',
        data:data
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(RouteActions.afterRevoke(response.data.result));
          RouteMiddleware.alertHendler(dispatch, response, true, 'Save Data Successfully', 'success')
        }
      })
      .catch((error) => {
        RouteMiddleware.alertHendler(dispatch,error)
      });
  }


  static show(){
    return (dispatch) => {
      RouteMiddleware.showOne(dispatch);
      // dispatch(RouteActions.update());
    };
  }
  static showOne(dispatch){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${RouteMiddleware.getToken()}`
        },
        url: url,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(RouteActions.view(response.data.result));
        }
      })
      .catch((error) => {
        RouteMiddleware.alertHendler(dispatch,error)
      });
  }


  static resetList(){
    return (dispatch) => {
        dispatch(RouteActions.resetList());
      };
  }
  static list(params){
      return (dispatch) => {
          dispatch(RouteActions.process());
          RouteMiddleware.showlist(dispatch, params);
        };
  }
  static reset(){
    return (dispatch) => {
        dispatch(RouteActions.reset());
      };
}
  static getOne(params){
    return (dispatch) => {
        dispatch(RouteActions.view());
        RouteMiddleware.showOne(dispatch, params);
      };
  }

  static beforeSaveNew(post,search){
    return (dispatch) => {
        dispatch(RouteActions.submit());
        RouteMiddleware.saveNew(dispatch, post,search);
      };
  }
  static beforeSaveUpdate(params,post,search){
    return (dispatch) => {
        dispatch(RouteActions.submit());
        RouteMiddleware.saveUpdate(dispatch, params, post,search);
      };
  }
  static beforeDelete(id,params){
    return (dispatch) => {
        dispatch(RouteActions.delete());
        RouteMiddleware.delete(dispatch,params,id);
      };
  }

  static getToken(){
      return cookieManager.getUserToken();
  }

  static getHelper(params=null){
    return (dispatch) => {
      RouteMiddleware.showHelper(dispatch,params);
      };
  }

 
  static showHelper(dispatch,params){
    axios({
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${RouteMiddleware.getToken()}`
        },
        url:process.env.REST_URL+'helper/get-helper-admin' ,
        responseType: 'json',
        params:params
      })
      .then((response) => {
        
        if (response && response.status === 200 && response.data) {
          dispatch(RouteActions.helper(response.data.result));
        }
      })
      .catch((error) => {
        RouteMiddleware.alertHendler(dispatch,error)
      });
  }

  static showlist(dispatch, params){
      axios({
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${RouteMiddleware.getToken()}`
          },
          url: url,
          responseType: 'json',
          params:params
        })
        .then((response) => {
          
          if (response && response.status === 200 && response.data) {
            dispatch(RouteActions.list(response.data.result));
          }
        })
        .catch((error) => {
          RouteMiddleware.alertHendler(dispatch,error)
        });
  }

  

  static delete(dispatch, params,id){
    axios({
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${RouteMiddleware.getToken()}`
        },
        url: url +'/'+id,
        responseType: 'json'
      })
      .then((response) => {
       
        if (response && response.status === 200 && response.data) {
          MySwal.close()
          dispatch(RouteActions.process(),RouteMiddleware.showlist(dispatch, params));
          RouteMiddleware.alertHendler(dispatch,response,true,'Delete Data Successfully','success')
        }
      })
      .catch((error) => {
        RouteMiddleware.alertHendler(dispatch,error,true)
      });
  }

  static saveNew(dispatch, post,search){
    axios({
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${RouteMiddleware.getToken()}`
        },
        url: url,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(RouteActions.process(),RouteMiddleware.showlist(dispatch,search));
          dispatch(RouteActions.success());
          RouteMiddleware.alertHendler(dispatch,response,true,'Create Data Successfully','success')
        }
      })
      .catch((error) => {
        RouteMiddleware.alertHendler(dispatch,error)
      });
  }

  static saveUpdate(dispatch, params, post, search){
    axios({
        method: 'PUT',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          Authorization: `Bearer ${RouteMiddleware.getToken()}`
        },
        url: url+'/'+params,
        data:post,
        responseType: 'json'
      })
      .then((response) => {
        if (response && response.status === 200 && response.data) {
          dispatch(RouteActions.process(),RouteMiddleware.showlist(dispatch,search));
          dispatch(RouteActions.success());
          RouteMiddleware.alertHendler(dispatch,response,true,'Update Data Successfully','success')
        }
      })
      .catch((error) => {
        RouteMiddleware.alertHendler(dispatch,error)
      });
  }

  static alertHendler(dispatch,result,isSwal=false,extraMessage='',type='error'){
    if(type=='error'){
      if (result.response) {
        const status=result.response.status
        switch(status){
          
          case 500:
            if(isSwal){
              const data=result.response.data
              MySwal.hideLoading()
              MySwal.update({
                title:'Delete Error',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              })
            }else{
              const data=result.response.data
              dispatch(RouteActions.error(data.error));
            }
          break;  
          case 403:
            console.log('Error 403');
          break;     
          case 404:
            console.log('Error 404');
          break;   
          case 401:
            const data=result.response.data
              MySwal.fire({
                title:'Login Invalid',
                html:data.error,
                icon:'error',
                showConfirmButton:true,
              }).then((result)=>{
                  if(result.isConfirmed){
                    <Navigate to="/login"></Navigate>
                  }
              })
          break;   
        }
      } else if (result.request) {
        MySwal.fire({
          title:'Internal Server Error',
          html:'Please info your Developer to fix this',
          icon:'error',
          showConfirmButton:true,
        })
        dispatch(RouteActions.reset());
      } else {
        // Something happened in setting up the request that triggered an Error
        console.log('Error', result.message);
      }
    }else{
      MySwal.fire({
        title:'Success',
        html:extraMessage,
        icon:'success',
        showConfirmButton:true,
      })
    }
  }
}
